import React from 'react';
import './kernelTabs.css';

/**
 * Schede di una pagina (barra orizzontale che scorre se non c'è spazio): `tabs` = [{ key, label }], `active` = la chiave
 * selezionata, `onChange(key)` quando se ne sceglie un'altra. Frecce sinistra/destra spostano la selezione.
 */
function KernelTabs({ tabs, active, onChange, label }) {
  const move = (event, index) => {
    if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
    event.preventDefault();
    const next = (index + (event.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length;
    onChange(tabs[next].key);
    const buttons = event.currentTarget.parentElement.querySelectorAll('[role="tab"]');
    if (buttons[next]) buttons[next].focus();
  };

  return (
    <div className="kernel-tabs" role="tablist" aria-label={label}>
      {tabs.map((tab, index) => (
        <button
          key={tab.key}
          type="button"
          role="tab"
          id={`kernel-tab-${tab.key}`}
          aria-selected={active === tab.key}
          tabIndex={active === tab.key ? 0 : -1}
          className={'kernel-tab' + (active === tab.key ? ' is-active' : '')}
          onClick={() => onChange(tab.key)}
          onKeyDown={(event) => move(event, index)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}

export default KernelTabs;
